import store from "../../store";

export default {
  install(Vue) {
    // ajax post
    Vue.prototype.$obituaryView = async obituary => {
      const data = await store.dispatch("REQUEST_ENCODE", obituary.id);

      if (data.result) {
        window.open(
          `${process.env.VUE_APP_OBITUARY_BASEURL}/?id=${data.str}&host=admin`,
          "부고장",
          "width=500,height=1500"
        );
      }
    };
  }
};
